export const iconFontAwesomeBuildingsHouseLock = (
	<i className="fa-solid fa-house-lock"></i>
);
